import { isArray } from "angular"
import { defineDirective } from "../../../omnia"
import { CroppingGroup } from "../dashboard"
import { TableDashboardContext } from "../dashboardContext"
import { PlanCroppingVm } from "../vm/planCroppingVm"
import { PlanVm } from "../vm/planVm"
import { canEditGroupRequirements, canResetGroupRequirements, hasAuthorizationsOnAnyInGroup } from "../permissions"

export class RequirementsTableCtrl {

    static create() {

        const def = defineDirective(RequirementsTableCtrl, "app/nutrition/dashboard/table/requirements/requirementsTable.html", {
            dashboard: "<"
        });

        def.link = (scope, element, attrs, ctrl: RequirementsTableCtrl) => {
            ctrl.link(element);
        };

        return def

    }

    public dashboard: TableDashboardContext;

    link(rootElement) {

        var tableHeaderElement = rootElement[0].querySelector(".table-head");

        var tableBodyElement = rootElement[0].querySelector(".table-body");

        tableBodyElement.addEventListener("scroll", e => {
            var left = tableBodyElement.scrollLeft;
            tableHeaderElement.scrollLeft = left;
        });

    }

    public isGroupingCropBased(): boolean {
        // Note: all the groupings that are currently supported are crop-based
        // If this changes, this method will have to be adapted
        return this.dashboard.croppingGroups && this.dashboard.croppingGroups.every(g => !!g.crop);
    }

    get readOnly() {
        const { dashboard } = this
        return dashboard ? (dashboard.edit || dashboard.readonly) : true
    }

    get showRequirementsLeft() {
        return this.dashboard.showRequirementsLeft;
    }

    get planId(): number {
        return this.dashboard.selectedPlan ? this.dashboard.selectedPlan.plan.NutritionPlanId : undefined;
    }

    getValueCellStyle(c: PlanCroppingVm, key: string) {

        if (this.dashboard) {
            return this.dashboard.getValueCellStyle(c, key);
        }

    }

    canChangeSelection(): boolean {
        if (this.dashboard) return this.dashboard.canChangeSelection();
    }

    toggleSelection(c: PlanCroppingVm) {
        if (this.dashboard) this.dashboard.toggleSelection(c);
    }

    canCreateNewPlanForGroup(group: CroppingGroup): boolean {
        return hasAuthorizationsOnAnyInGroup(group)
            && this.dashboard
            && this.dashboard.canCreateNewPlanForGroup(group);
    }

    createNewPlanForGroup(group: CroppingGroup) {
        return this.dashboard?.createNewPlanForGroup(group);
    }

    editRequirements(cropping: PlanCroppingVm) {
        this.dashboard.cropping.filter(c => c.selected).forEach(c => c.selected = false);
        cropping.selected = true;
        this.dashboard.editRequirements();
    }

    calculateGroupRequirements(group: CroppingGroup) {
        return this.dashboard?.calculateGroupRequirements(group);
    }

    canCalculateRequirements(group: CroppingGroup) {
        return hasAuthorizationsOnAnyInGroup(group)
    }

    canEditGroupRequirements(group: CroppingGroup) {
        return canEditGroupRequirements(group)
    }

    editGroupRequirements(group: CroppingGroup) {

        if (group) {
            if (!group.cropping.filter(c => c.selected).length) {
                this.dashboard.cropping.filter(c => c.selected).forEach(c => c.selected = false);
                group.cropping.filter(c => c.hasRequirements)[0].selected = true;
            } else if (group.cropping.filter(c => c.selected).length > 1) {
                var cropping = this.dashboard.cropping.filter(c => c.selected)[0];
                this.dashboard.cropping.filter(c => c.selected && c !== cropping).forEach(c => c.selected = false);
            }

            return this.dashboard.editRequirements();
        }

    }

    canResetGroupRequirements(group: CroppingGroup) {
        return canResetGroupRequirements(group)
    }

    resetRequirements(group: CroppingGroup) {

        var selection = group.cropping.filter(c => c.selected);
        if (!selection.length) {
            selection = group.cropping;
        }

        var ids = selection.filter(c => !!c.requirements && !c.isInPlan && !c.isZone).map(c => c.croppingId);

        this.dashboard.resetRequirements(ids);

    }

    editPlan(p: PlanVm, $event: ng.IAngularEvent) {

        if (this.dashboard) {
            this.dashboard.updatePlan(p, $event);
        }

    }


}

